import { createFileRoute, redirect } from '@tanstack/react-router';

// /dashboard/social-ads/templates — kept only as a redirect to the unified
// /create surface, which now owns the inline template picker (mirrors the
// /dashboard/emails/create flow). Old bookmarks land in the right place.

export const Route = createFileRoute('/_authed/dashboard/o/$orgId/c/$clientId/social-ads/templates')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/dashboard/o/$orgId/c/$clientId/social-ads/create',
      params: { orgId: params.orgId, clientId: params.clientId },
    });
  },
});
